import { Injectable } from '@angular/core';

export interface TraceParent {
  traceparent: string;
  traceId: string;
  spanId: string;
}

@Injectable({ providedIn: 'root' })
export class TraceContextService {
  private readonly sessionPrefix: string = makeNonZeroPrefix();
  private requestCounter = 0;

  getSessionPrefix(): string {
    return this.sessionPrefix;
  }

  nextTraceparent(): TraceParent {
    const requestIndexHex = this.requestCounter.toString(16).padStart(24, '0');
    this.requestCounter += 1;

    const traceId = this.sessionPrefix + requestIndexHex;
    const spanId = randomHex(8);
    const traceparent = `00-${traceId}-${spanId}-01`;

    return { traceparent, traceId, spanId };
  }
}

function randomHex(byteLength: number): string {
  const bytes = new Uint8Array(byteLength);
  crypto.getRandomValues(bytes);
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

// Guarantees a non-zero 8-hex session prefix. An all-zero traceId is
// invalid per W3C trace-context (vendors MUST ignore it). The 2^-32
// probability is microscopic, but the guard is cheap.
function makeNonZeroPrefix(): string {
  let prefix = randomHex(4);
  while (prefix === '00000000') {
    prefix = randomHex(4);
  }
  return prefix;
}
